export const ActionTypes = {
    EMAIL_REPLY_CLOSED: 'EMAIL_REPLY_CLOSED',
    EMAIL_REPLY_OPENED: 'EMAIL_REPLY_OPENED',
    EMAIL_REPLY_MINIMIZED: 'EMAIL_REPLY_MINIMIZED',
    EMAIL_REPLY_ENLARGED: 'EMAIL_REPLY_ENLARGED',
} as const;

type EmailReplyClosedAction = {
    type: 'EMAIL_REPLY_CLOSED';
};
type EmailReplyOpenedAction = {
    type: 'EMAIL_REPLY_OPENED';
    payload: {
        replyToEmailId: string;
        isReplyingAll: boolean;
        onReplySuccess?: () => void;
        suggestedEmailReplyId?: string;
    };
};
type EmailReplyMinimizedAction = {
    type: 'EMAIL_REPLY_MINIMIZED';
};
type EmailReplyEnlargedAction = {
    type: 'EMAIL_REPLY_ENLARGED';
};

export type EmailReplyAction =
    | EmailReplyOpenedAction
    | EmailReplyClosedAction
    | EmailReplyMinimizedAction
    | EmailReplyEnlargedAction;

/*
 * Action creators
 */
export const closeReplyModal = (): EmailReplyClosedAction => ({
    type: ActionTypes.EMAIL_REPLY_CLOSED,
});

export const openReplyModal = (input: {
    replyToEmailId: string;
    isReplyingAll?: boolean;
    onReplySuccess?: () => void;
    suggestedEmailReplyId?: string;
}): EmailReplyOpenedAction => ({
    type: ActionTypes.EMAIL_REPLY_OPENED,
    payload: {
        replyToEmailId: input.replyToEmailId,
        isReplyingAll: input.isReplyingAll || false,
        onReplySuccess: input.onReplySuccess,
        suggestedEmailReplyId: input.suggestedEmailReplyId,
    },
});

export const minimizeReplyModal = (): EmailReplyMinimizedAction => ({
    type: ActionTypes.EMAIL_REPLY_MINIMIZED,
});

export const enlargeReplyModal = (): EmailReplyEnlargedAction => ({
    type: ActionTypes.EMAIL_REPLY_ENLARGED,
});
